import { useStyletron } from "baseui";
import { Bar } from "react-chartjs-2";
import { DisplayMode, useGetBuildingsEnergy } from "../../../../hooks/useGetBuildingsEnergy";
import { useMemo } from "react";
import { LoadingView } from "../../../../components";
import { IBaseCounter } from "../../../Devices/BaseCounter";
import { CounterType } from "../../../Devices/CounterType";
import { CounterMedium } from "../../../Devices/CounterMedium";


const PortfolioEnergyChart = (props: { colors: string[], color: string, byM2: boolean, start: Date, end: Date, take: number, displayMode: DisplayMode, filterCounters?: (c: IBaseCounter) => boolean, medium?: CounterMedium | undefined, valueFactor: number | undefined, dimension: string | undefined }) => {
    const [css, theme] = useStyletron();


    const displayUnitString = props.dimension ?? displayModeUnits[props.displayMode];
    const valueFactor = props.valueFactor !== undefined ? props.valueFactor : 1;

    const { items: energyData, average, isLoading, error, isSuccess } = useGetBuildingsEnergy( props.displayMode, props.start, props.end, 'year', props.byM2, props.filterCounters ?? filterCounters,props.medium);
    const top5Sum = useMemo(() => {
        const tmp = energyData?.map((v) => {
            return { building: v.building, sum: v.data.reduce((partialSum, a) => partialSum +  a.sumValue * valueFactor, 0) }
        })
        return tmp?.sort((a, b) => b.sum - a.sum).slice(0, props.take)
    }, [energyData]);


    const labels = top5Sum?.map((v: any) => v.building?.description);
    const datasetData = top5Sum?.map((v: any) => v.sum);
    const m2text = props.byM2 ? '/m²' : '';
    const annotation = {
        type: 'line',
        drawTime: 'afterDraw',
        borderColor: theme.colors.backgroundInverseSecondary,
        borderDash: [6, 6],
        borderDashOffset: 0,
        borderWidth: 1,
        label: {
            font: { weight: 'normal' },
            display: true,
            content: (ctx) => {
                const avg = averageFunc(ctx);
                return 'Ø ' + valueToThousands(avg) + ' ' + displayUnitString + m2text;
            },
            position: 'end',
        },
        scaleID: 'x',
        value: (ctx) => averageFunc(ctx),
    };

    const data = {
        labels: labels,
        datasets: [{
            axis: 'y',
            data: datasetData,
            fill: false,
            backgroundColor: props.colors,
            borderWidth: 0,
            borderRadius: 5,
        },
        /*{
            label: "Average",
            backgroundColor: "rgb(255, 0, 0)",
            data: [average,average,average,average].map(v => [v + 0.0, v + 0.1]),
            yAxisID: 'y2',
            order: -1
          }*/]
    };
    // see https://www.chartjs.org/docs/latest/axes/cartesian/#common-configuration
    const myOptions: any = {
        type: 'bar',
        plugins: {
            title: { display: false }, legend: { display: false }, annotation: {
                annotations: {
                    annotation
                }
            }
        },
        responsive: true,
        indexAxis: 'y',
        scales: {
            y: {
                grid: { display: false },
                ticks:
                {
                    padding: 10,
                    font: theme.typography.LabelXSmall,
                    color: props.color,
                    mirror: true,
                    z: 99999,
                }
            },
            y2: {
                display: false
            },
            x: {
                grid: { display: false },
                ticks: { callback: function (value, index, array) { return valueToThousands(value); } }
            }
        }
    };

    return (<>
        <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
            <Bar data={data} datasetIdKey='id' options={myOptions}  ></Bar>
        </LoadingView>
    </>)

    function averageFunc(ctx) {
        const values = ctx.chart.data.datasets[0].data;
        return values.reduce((a, b) => a + b, 0) / values.length;
    }
}

export default PortfolioEnergyChart

function valueToThousands(value: number): string | number {
    const decimals = value > 1000 ? 0 : 1;
    return (value < 1000000) ? ((value < 1000) ? value.toFixed(decimals) : (value / 1000).toFixed(0) + 'K') : (value / 1000000).toFixed(0) + 'M';
}

function filterCounters(x: IBaseCounter) {
    return x.counterType === CounterType.FeedIn || x.counterType === CounterType.FeedOut
}

interface IDictionary {
    [index: string]: any;
}

const displayModeUnits: IDictionary = {
    [DisplayMode.EUR]: "€",
    [DisplayMode.CO2]: "kg",
    [DisplayMode.KWH]: "kWh",
    [DisplayMode.M3]: "m³",
}



